module.exports = __webpack_public_path__ + "img/cnu_main2.337b92ed.jpg";